<template>
  <div class="page">
    <Header :title="course.courseName" :show-back="true" />

    <video id="video" :src="course.courseFileLink" class="video-obj"
      playsinline webkit-playsinline controls type="video/mp4" preload="yes" :poster="poster">
      Video player not available.
    </video>
  </div>
</template>

<script>
import Header from '@/components/header'
import { commonUtils } from '@/utils/common'
export default {
  name: 'CourseVideoView',
  components: {
    Header
  },
  data () {
    return {
      course: {}
    }
  },
  computed: {
    poster () {
      return this.getImageUrl(this.course.courseImageUri)
    }
  },
  mounted () {
    // console.log(this.$route.query.course)
    this.course = JSON.parse(this.$route.query.course)
  },
  methods: {
    getImageUrl: commonUtils.getImageUrl
  }
}
</script>

<style lang="less" scoped>
.video-obj {
  width: 100%;
}
</style>
